var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalancedYou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3200,
    height: 1800,
    viewBox: "0 0 3200 1800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1945_7468)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 1626.5,
    cy: 1492.5,
    rx: 1002.5,
    ry: 115.5,
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1673.67 572.845L1200.28 590.186L811.287 584.451L792.378 618.865L1596.96 712.441L1673.67 572.845Z",
    fill: "#997659"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1596.66 586.702L1623.15 1059.66L1624.94 1448.7L1659.72 1466.94L1737.71 660.692L1596.66 586.702Z",
    fill: "#997659"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1611.06 1446.9C1606.63 1456.34 1604.22 1463.48 1603.83 1468.32C1603.35 1474.2 1603.64 1482.87 1604.69 1494.31C1611.52 1494.86 1672.84 1499.8 1788.67 1509.14C1794.72 1493.72 1792.65 1484.96 1782.45 1482.87C1772.25 1480.78 1763.79 1478.95 1757.06 1477.39L1674.62 1432.38C1673.03 1431.51 1671.04 1432.09 1670.18 1433.68C1670.16 1433.71 1670.15 1433.73 1670.13 1433.76L1663.56 1446.65C1653.67 1450.33 1645.74 1451.93 1639.78 1451.45C1634.94 1451.06 1628.4 1448.57 1620.18 1443.97L1620.18 1443.97C1617.03 1442.2 1613.04 1443.33 1611.28 1446.48C1611.2 1446.62 1611.13 1446.75 1611.06 1446.9Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1602.41 1376.44L1680.11 1391.33C1696.8 1288.09 1691.23 1172.55 1703.92 1044.7C1716.61 916.857 1729.84 791.046 1732.35 667.27L1557.59 567.921C1546.91 720.559 1556.71 863.575 1564.48 996.969C1572.24 1130.36 1577.38 1256.85 1602.41 1376.44Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M876.344 577.942L860.905 655.534C964.027 672.956 1079.46 668.865 1207.22 682.459C1334.97 696.053 1612.74 734.064 1736.49 737.452L1685.16 538.838C1532.6 527.084 1389.6 544.215 1256.16 551.037C1122.71 557.858 996.106 553.761 876.344 577.942Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2234.5 656.121C2203.37 681.417 2114.9 696.135 2104.07 673.26C2099.75 664.138 2101.87 642.527 2110.42 619.306L2020.52 650.135L2005.69 573.01L2134.55 575.762C2149.08 557.613 2168.46 543.496 2192.65 540.581C2262.35 532.182 2265.63 630.824 2234.5 656.121Z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2117.93 572.814C2159.13 554.853 2183.19 521.631 2203.25 522.142C2216.62 522.482 2226.04 528.431 2231.5 539.989C2258.15 541.386 2272.87 559.587 2275.67 594.594C2279.85 647.103 2264.54 682.589 2214.95 678.072C2212.55 665.615 2214.17 649.71 2202.45 630.399C2198.73 624.272 2190.23 621.013 2176.94 620.623L2175.13 611.226C2188.5 599.198 2192.33 589.137 2186.61 581.043C2180.9 572.949 2170.78 572.805 2156.25 580.613L2119.85 582.811L2117.93 572.814Z",
    fill: "#181658"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2517.51 602.784C2500.01 609.256 2481.89 616.851 2482.21 623.691C2482.52 630.53 2495.93 632.723 2494.79 642.672C2494.03 649.305 2473.2 643.126 2432.29 624.135L2320.47 628.365L2317.61 566.899L2444.47 592.944C2473.38 588.06 2498.84 586.816 2520.85 589.212C2526.63 591.053 2535.02 596.311 2517.51 602.784Z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1638.93 541.48L1725.91 777.669C1886.08 688.748 2014.78 660.066 2078.25 646.601C2081.49 645.915 2086.06 638.816 2084.8 636.306C2075.59 617.953 2073.64 596.792 2078.97 572.823C1973.34 532.304 1797 523.098 1638.93 541.48Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2450.19 592.918C2450.19 608.517 2415.89 630.481 2415.89 630.481L2046.28 647.339L1946.96 662.564C1946.96 662.564 1652.57 757.406 1636.17 672.084L1610.79 540.146C1747.59 492.112 1953.44 503.107 2061.74 535.225C2065.88 536.452 2084.36 541.473 2084.36 541.473L2126.82 552.284C2126.77 552.311 2308.92 564.337 2308.92 564.337C2308.92 564.337 2450.18 579.852 2450.19 592.918Z",
    fill: "#F2ACA7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M813.351 570.609C803.992 565.993 796.898 563.443 792.07 562.959C786.198 562.372 777.532 562.492 766.071 563.321C765.389 570.133 759.261 631.35 747.687 746.974C762.987 753.326 771.78 751.424 774.068 741.268C776.355 731.111 778.346 722.683 780.041 715.983L826.639 634.432C827.536 632.863 826.991 630.864 825.422 629.967C825.395 629.952 825.368 629.937 825.341 629.922L812.58 623.103C809.092 613.14 807.645 605.182 808.241 599.231C808.725 594.396 811.346 587.914 816.105 579.785L816.105 579.785C817.931 576.666 816.882 572.656 813.763 570.83C813.628 570.752 813.491 570.678 813.351 570.609Z",
    fill: "#E4E4E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1945_7468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3200,
    height: 1800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalancedYou);
export default __webpack_public_path__ + "static/media/balanced-you.24070b34683e24abd18030f8a743b859.svg";
export { ForwardRef as ReactComponent };